import { faCircleCheck, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme, lighten, darken } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { UserClockIcon } from "../../../../assets/icons";
import { PresenceAndLeavesSummaryDTO } from "../../../../models/presence-and-leaves-summary/presence-and-leaves-summary-dto";
import IconAndTitleContainer from "../../reusable-widget-link-components/IconAndTitleContainer/IconAndTitleContainer";

const MyTeamWorkedTimeLink = ({
  customSummary,
  loading,
}: {
  customSummary: PresenceAndLeavesSummaryDTO;
  loading: boolean;
}) => {
  const theme = useTheme();
  const tRP = "components.custom_widget_links.my_team_presence_and_leaves";
  const { t } = useTranslation();
  return (
    <IconAndTitleContainer
      title={`${t(`${tRP}.worked_time`)}`}
      Icon={UserClockIcon}
      loading={loading}
      endAdornment={
        !loading ? (
          customSummary.workedTime ? (
            <FontAwesomeIcon
              icon={faCircleCheck}
              color={lighten(theme.palette.success.main, 0.2)}
              style={{ fontSize: "18px" }}
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              color={theme.palette.error.main}
              style={{ fontSize: "18px" }}
            />
          )
        ) : (
          <></>
        )
      }
      titleStyle={{
        color: darken(theme.palette.text.secondary, 0.15),
      }}
      IconStyle={{ width: "25px" }}
      customStyle={{ width: "100%", justifyContent: "space-between" }}
    />
  );
};
export default MyTeamWorkedTimeLink;
